import { render } from "./CustomerContactInfoView.vue.ts?vue&type=template&id=62a251fd&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfoView.vue?vue&type=template&id=62a251fd&scoped=true&ts=true"
import script from "./CustomerContactInfoView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerContactInfoView.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfoView.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerContactInfoView.vue.css?vue&type=style&index=0&id=62a251fd&scoped=true&lang=css!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfoView.vue?vue&type=style&index=0&id=62a251fd&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a251fd"],['__file',"src/apps/merchant3/components/customer-registration/views/CustomerContactInfoView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62a251fd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62a251fd', __exports__)) {
    api.reload('62a251fd', __exports__)
  }
  
  module.hot.accept("./CustomerContactInfoView.vue.ts?vue&type=template&id=62a251fd&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./CustomerContactInfoView.vue?vue&type=template&id=62a251fd&scoped=true&ts=true", () => {
    api.rerender('62a251fd', render)
  })

}


export default __exports__